import { ApiError, createEvent } from '@jq4race/api-client';
import { LocalizedError, useTranslation } from '@jq4race/i18n';
import type { CreateEventRequest } from '@jq4race/shared';
import { buttonVariants, Card, CardContent } from '@jq4race/ui';
import { Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { translateApiError } from '../../../../shared/errors/translateApiError';
import { PageHeader } from '../../../app-shell/ui/PageHeader';
import { EventForm } from '../components/EventForm';

export function NewEventPage() {
  const { t } = useTranslation('events');
  const navigate = useNavigate();

  async function handleSubmit(values: CreateEventRequest) {
    try {
      await createEvent(values);
      void navigate({ to: '/dashboard/events' });
    } catch (e) {
      if (e instanceof ApiError) {
        throw new LocalizedError(
          translateApiError(e, t, { fallback: t('newEventPage.genericError') }),
        );
      }
      throw e;
    }
  }

  return (
    <div className="space-y-8">
      <PageHeader
        eyebrow={t('newEventPage.eyebrow')}
        title={t('newEventPage.title')}
        description={t('newEventPage.description')}
        actions={
          <Link to="/dashboard/events" className={buttonVariants({ size: 'sm', variant: 'ghost' })}>
            <ArrowLeft className="h-4 w-4" strokeWidth={1.75} />
            {t('newEventPage.backToList')}
          </Link>
        }
      />

      <Card className="border-jq-sand/70 bg-jq-surface-0 shadow-sm">
        <CardContent className="p-6 sm:p-8">
          <EventForm
            mode="create"
            onSubmit={handleSubmit}
            submitLabel={t('newEventPage.createEvent')}
            onCancel={() => void navigate({ to: '/dashboard/events' })}
          />
        </CardContent>
      </Card>
    </div>
  );
}
